import { Box, Select, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

export default function OrderMenu({ onSortChange, sort }) {
  const onValueChange = (e) => {
    onSortChange(e.target.value);
  };

  useEffect(() => onSortChange('status'), []);

  return (
    <Box
      width={'full'}
      defaultValue={sort}
      display={'flex'}
      alignItems={'center'}
      columnGap={6}
    >
      <Text as="label" htmlFor="list-sort" userSelect={'none'} flexShrink={0}>
        Sorteren op{' '}
      </Text>
      <Select id="list-sort" onChange={onValueChange}>
        <option value="status">Status</option>
        <option value="costASC">Prijs - oplopend</option>
        <option value="costDESC">Prijs - aflopend</option>
        <option value="livingSurfaceASC">Woonoppervlakte - oplopend</option>
        <option value="livingSurfaceDESC">Woonoppervlakte - aflopend</option>
        <option value="plotSurfaceASC">Kaveloppervlakte - oplopend</option>
        <option value="plotSurfaceDESC">Kaveloppervlakte - aflopend</option>
        <option value="number">Bouwnummer - oplopend</option>
        <option value="numberDESC">Bouwnummer - aflopend</option>
        <option value="typeASC">Woningtype - A-Z</option>
        <option value="typeDESC">Woningtype - Z-A</option>
      </Select>
    </Box>
  );
}

OrderMenu.propTypes = {
  sort: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
};
